import { render } from "./SearchFormComponent.vue?vue&type=template&id=53452084&scoped=true&ts=true"
import script from "./SearchFormComponent.ts?vue&type=script&lang=ts"
export * from "./SearchFormComponent.ts?vue&type=script&lang=ts"

import "./SearchFormComponent.scss?vue&type=style&index=0&id=53452084&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/maximum/maximum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53452084"]])

export default __exports__